import React from "react";
import logo from "../assets/pokeapi_256.png";

const Mylogo = () => {
  return (
    <div className="pb-10">
      <img src={logo} alt="logo of pokemon" />
    </div>
  );
};

export default Mylogo;
